import { Formik, Form, ErrorMessage } from 'formik';
import { useState } from 'react';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { useFormik } from 'formik';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useAddPage from 'hooks/useAddPage';
const GrouploantransactionAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanaccountno')),
		transactiondate: yup.string().required().label($t('transactiondate')),
		period: yup.number().required().label($t('period')),
		ac_code: yup.string().required().label($t('acCode')),
		debit: yup.number().required().label($t('debit')),
		credit: yup.number().required().label($t('credit')),
		total: yup.number().nullable().label($t('total')),
		remarks: yup.string().nullable().label($t('remarks')),
		branchcode: yup.string().required().label($t('branchcode')),
		empcode: yup.string().required().label($t('empcode')),
		userid: yup.number().nullable().label($t('userid')),
		checked_yn: yup.number().required().label($t('checkedYn')),
		checked_by: yup.number().nullable().label($t('checkedBy'))
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		transactiondate: new Date(), 
		period: '', 
		ac_code: '', 
		debit: "((0))", 
		credit: "((0))", 
		total: "0", 
		remarks: '', 
		branchcode: '', 
		empcode: '', 
		userid: auth.userId, 
		checked_yn: "((0))", 
		checked_by: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/grouploantransaction`);
		}
	}
	
	//auto fill other inputs on loanaccountno change
	async function loanaccountnoAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/grouploantransaction_loanaccountno_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('transactiondate', data.paydate);
formik.setFieldValue('period', data.period);
formik.setFieldValue('credit', data.payment);
formik.setFieldValue('branchcode', data.branchcode);
formik.setFieldValue('empcode', data.empcode_collection);
		}
	};
const formik = useFormik({
    initialValues: {
        loanaccountno: "",
    },
});
const [loanInfo, setLoanInfo] = useState({
    balance: 0,
    overdue: 0,
    due: 0,
    emiDue: 0,
    emiPaid: 0,
    forecloser: 0
});
// Helper function to parse date for PrimeReact Calendar
const parseDateForCalendar = (dateValue) => {
    if (!dateValue) return null;
    // If it's already a Date object
    if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
        return dateValue;
    }
    // If it's a timestamp
    if (typeof dateValue === 'number') {
        return new Date(dateValue);
    }
    // If it's a string
    if (typeof dateValue === 'string') {
        // Try common formats
        // Format: "2026-01-07" (YYYY-MM-DD)
        const ymdMatch = dateValue.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
        if (ymdMatch) {
            const [, year, month, day] = ymdMatch;
            return new Date(year, month - 1, day);
        }
        // Format: "7 Jan 2026"
        const dmyMatch = dateValue.match(/(\d{1,2})\s+(\w+)\s+(\d{4})/);
        if (dmyMatch) {
            const months = {
                'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
                'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
            };
            const [, day, monthStr, year] = dmyMatch;
            const monthIndex = months[monthStr];
            if (monthIndex !== undefined) {
                return new Date(year, monthIndex, day);
            }
        }
        // Try standard Date parsing as last resort
        const parsedDate = new Date(dateValue);
        if (!isNaN(parsedDate.getTime())) {
            return parsedDate;
        }
    }
    return null;
};
//auto fill other inputs on loanaccountno change
async function loanaccountnoAutoFill(e, formik, index) {
    formik.handleChange(e);
    const val = e.target.value;
    const resp = await api.get(`components_data/grouploantransaction_loanaccountno_autofill?value=${val}`);
    const data = resp.data[0];
    if(data){
         const transactionDate = parseDateForCalendar(data.paydate);
        formik.setFieldValue('transactiondate', transactionDate);
        formik.setFieldValue('period', data.period);
        formik.setFieldValue('credit', data.payment);
        formik.setFieldValue('branchcode', data.branchcode);
        formik.setFieldValue('empcode', data.empcode_collection);
    }
    // Fetch balance info
    const apiUrl = `${process.env.REACT_APP_API_PATH}loan/GetLoanDetails/${val}`;
    const response = await fetch(apiUrl);
    const data2 = await response.json();
    if (data2) {
        setLoanInfo({
            balance: data2.balance ?? 0,
            overdue: data2.overdue ?? 0,
            due: data2.due ?? 0,
            emiDue: data2.emiDue ?? 0,
            emiPaid: data2.emiPaid ?? 0,
            forecloser: data2.forecloser ?? 0
        });
    }
};
function EmptyRecordMessage(){
    if(pageReady && !records.length){
        return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
        {$t('noRecordFound')}
        </div>
        );
    }
}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="GrouploantransactionAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewLoanTransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div className="">
                        <div className="page-records">
                            {/* Header */}
                            <div style={{
                                backgroundColor: "#0d3c61", 
                                color: "white", 
                                fontSize: "12px",
                                padding: "10px",
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "10px"
                                }}>
                                <div>LEDGER BALANCE</div>
                                <div>INTEREST OVERDUE</div>
                                <div>TOTAL DUE</div>
                                <div>EMI DUE</div>
                                <div>EMI PAID</div>
                                <div>FORECLOSER</div>
                            </div>
                            {/* Data Row */}
                            <div style={{
                                backgroundColor: "lightgray", 
                                color: "blue", 
                                fontSize: "12px",
                                padding: "10px",
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "10px"
                                }}>
                                <div>{loanInfo?.balance?.toFixed(2)}</div>
                                <div>{loanInfo?.overdue?.toFixed(2)}</div>
                                <div>{loanInfo?.due?.toFixed(2)}</div>
                                <div>{loanInfo?.emiDue?.toFixed(2)}</div>
                                <div>{loanInfo?.emiPaid?.toFixed(2)}</div>
                                <div>{loanInfo?.forecloser?.toFixed(2)}</div>
                            </div>
                        </div>
                    </div>
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanaccountno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanaccountno_option_list_4"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="loanaccountno"     optionLabel="label" optionValue="value" value={formik.values.loanaccountno} onChange={(e)=>loanaccountnoAutoFill(e, formik)} options={response} label={$t('loanaccountno')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.loanaccountno)}   />
                                                    <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiondate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiondate" showButtonBar className={inputClassName(formik?.errors?.transactiondate)} dateFormat="yy-mm-dd" value={formik.values.transactiondate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="transactiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('period')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="period"  onChange={formik.handleChange}  value={formik.values.period}   label={$t('period')} type="number" placeholder={$t('enterPeriod')}  min={0}  step="any"    className={inputClassName(formik?.errors?.period)} />
                                                <ErrorMessage name="period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acCode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_code_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_code"     optionLabel="label" optionValue="value" value={formik.values.ac_code} onChange={formik.handleChange} options={response} label={$t('acCode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.ac_code)}   />
                                                    <ErrorMessage name="ac_code" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('debit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="debit"  onChange={formik.handleChange}  value={formik.values.debit}   label={$t('debit')} type="number" placeholder={$t('enterDebit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.debit)} />
                                                <ErrorMessage name="debit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('credit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit"  onChange={formik.handleChange}  value={formik.values.credit}   label={$t('credit')} type="number" placeholder={$t('enterCredit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.credit)} />
                                                <ErrorMessage name="credit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('total')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="total"  onChange={formik.handleChange}  value={formik.values.total}   label={$t('total')} type="number" placeholder={$t('enterTotal')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.total)} />
                                                <ErrorMessage name="total" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('remarks')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="remarks"  onChange={formik.handleChange}  value={formik.values.remarks}   label={$t('remarks')} type="text" placeholder={$t('enterRemarks')}        className={inputClassName(formik?.errors?.remarks)} />
                                                <ErrorMessage name="remarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('checkedYn')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="checked_yn"  onChange={formik.handleChange}  value={formik.values.checked_yn}   label={$t('checkedYn')} type="number" placeholder={$t('enterCheckedYn')}  min={0}  step="any"    className={inputClassName(formik?.errors?.checked_yn)} />
                                                <ErrorMessage name="checked_yn" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('checkedBy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="checked_by"  onChange={formik.handleChange}  value={formik.values.checked_by}   label={$t('checkedBy')} type="number" placeholder={$t('enterCheckedBy')}  min={0}  step="any"    className={inputClassName(formik?.errors?.checked_by)} />
                                                <ErrorMessage name="checked_by" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
GrouploantransactionAddPage.defaultProps = {
	primaryKey: 'loantransactionid',
	pageName: 'grouploantransaction',
	apiPath: 'grouploantransaction/add',
	routeName: 'grouploantransactionadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default GrouploantransactionAddPage;
